import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@shared/shared.module';
import { initializeCoreFactory } from './initializer/core.initializer';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { CustomExceptionInterceptor } from './interceptors/custom-exception.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { AnalyticsService } from './services/analytics.service';
import { AuctionService } from './services/auction.service';

@NgModule({
  declarations: [],
  exports: [],
  imports: [
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    SharedModule,
    TranslateModule,
    FormsModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: AuthInterceptor,
    },
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: CustomExceptionInterceptor,
    },
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: ErrorInterceptor,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeCoreFactory,
      deps: [AuctionService, AnalyticsService, Router],
      multi: true,
    },
    // NOTE: HttpClient itself is configured once, in AppModule. The
    // HTTP_INTERCEPTORS above are picked up from there via
    // `withInterceptorsFromDi()`.
  ],
})
export class CoreModule {}
